module.exports = require('./lodash');


//////////////////
// WEBPACK FOOTER
// ./~/lodash/index.js
// module id = 994
// module chunks = 1